import {Component, OnInit, ViewChild} from '@angular/core';
import {EnumTipoDeCupom} from "../../../../server/lib/emun/EnumTipoDeCupom";
import {CuponsService} from "../../superadmin/services/cupons.service";
import {NgForm} from "@angular/forms";
import {DialogRef} from "@progress/kendo-angular-dialog";
import {ProdutoService} from "../../services/produto.service";
import {EmpresasService} from "../../superadmin/services/empresas.service";
import {ConstantsService} from "../../fidelidade/ConstantsService";
declare let moment;
@Component({
  selector: 'app-cad-cupom',
  templateUrl: './cad-cupom.component.html',
  styleUrls: ['./cad-cupom.component.scss']
})
export class CadCupomComponent implements OnInit {
  @ViewChild('frm') frm: NgForm;
  cupom: any = { categorias: [], produtosTemplateTamanho: []};
  aplicarSomenteNasCategorias = true;
  EnumTipoDeCupom = EnumTipoDeCupom;
  tiposDeCupoms = [EnumTipoDeCupom.Valor, EnumTipoDeCupom.Percentual ];
  windowRef: DialogRef;
  salvando: any;
  mensagemErro: any;
  produtos: any = [   { descricao: ''}];
  categorias = []
  tamanhosPizzas: any = [];
  buscando: boolean;
  timerBusca;
  hoje;
  empresa: any;
  disponibilidadesSemana  = [
    { dia: 0 , label: 'Dom', disponivel: false },
    { dia: 1 , label: 'Seg', disponivel: false },
    { dia: 2 , label: 'Ter', disponivel: false },
    { dia: 3 , label: 'Qua', disponivel: false },
    { dia: 4 , label: 'Qui', disponivel: false },
    { dia: 5 , label: 'Sex', disponivel: false },
    { dia: 6 , label: 'Sab', disponivel: false }
  ]
  mensagemSucesso: string;
  formasDePagamento: any = []
  // cada seção responde uma pergunta do lojista; só a primeira é obrigatória
  secao = 'desconto';
  secoes = [
    { id: 'desconto', titulo: 'O desconto', curto: 'Desconto', icone: 'fas fa-tag' },
    { id: 'quem', titulo: 'Quem pode usar', curto: 'Quem', icone: 'fas fa-user-friends' },
    { id: 'pedidos', titulo: 'Em quais pedidos', curto: 'Pedidos', icone: 'fas fa-shopping-bag' },
    { id: 'quando', titulo: 'Quando e quanto', curto: 'Quando', icone: 'far fa-calendar-alt' }
  ];
  // campos de cada seção, para levar o usuário até o erro ao salvar
  camposPorSecao: { [secao: string]: Array<string> } = {
    desconto: ['codigo', 'nome', 'tipoCupom', 'valor', 'percentual', 'alvo'],
    quem: [],
    pedidos: ['valorMinimo', 'escopo', 'formaEntrega', 'valorMaximoDescontoProduto'],
    quando: ['validade', 'quantidade', 'qtdeMaxima']
  };
  escopos = [
    { valor: 'livre', label: 'Todos os canais' },
    { valor: 'loja', label: 'Só no cardápio' },
    { valor: 'app', label: 'Só no aplicativo' },
    { valor: 'mesas', label: 'Só em mesas' }
  ];
  formasEntrega = [
    { valor: '', label: 'Todas' },
    { valor: 'delivery', label: 'Delivery' },
    { valor: 'retirada', label: 'Retirada' },
    { valor: 'comerlocal', label: 'Comer no local' }
  ];
  codigoCopiado = false;
  timerCopiado;
  constructor(private cuponsService: CuponsService, private empresasService: EmpresasService,
              private constantsService: ConstantsService,
              private produtoService: ProdutoService) {
    this.hoje = moment().add(-1, 'd').toDate();

    this.constantsService.empresa$.subscribe( empresa => {
         if(empresa && empresa.id) {
           this.categorias = empresa.catalogo.categorias;
           this.formasDePagamento = empresa.formasDePagamento || []
         }
    }  );

    this.empresasService.obtenhaTemplatesEmpresaLogada( ).then( (templates) => {
      if(templates && templates.length){
        this.tamanhosPizzas.push( { descricao: ''})
        templates.forEach( template => {
            template.tamanhos.forEach( tamanho => {
               this.tamanhosPizzas.push( { id: tamanho.id, descricao: String(`${template.nome} - ${tamanho.descricao}`)});
            })
        })

        if(this.cupom.produtosTemplateTamanho){
          let ids: Array<number> =
            this.cupom.produtosTemplateTamanho.map((item: any) => item.id);

          this.cupom.produtosTemplateTamanho =
            this.tamanhosPizzas.filter( (tamanhoPizza: any) => ids.indexOf(tamanhoPizza.id) >= 0  );
        }
      }
    });
  }

  ngOnInit(): void {
    if(!this.cupom.id)
      this.cupom.tipo = this.tiposDeCupoms[0];

    if(this.cupom.valorMinimo == null) this.cupom.valorMinimo = 0;

    this.aplicarSomenteNasCategorias = this.cupom.aplicarSomenteNasCategorias == null ?
      !(this.cupom.produtos?.length && !this.cupom.brindeResgate) && !this.cupom.produtosTemplateTamanho?.length :
      this.cupom.aplicarSomenteNasCategorias;

    if(!this.cupom.id && this.cupom.aplicarSomenteNasCategorias == null)
      this.cupom.aplicarSomenteNasCategorias = this.aplicarSomenteNasCategorias;

    this.cupom.alvo =  this.cupom.aplicarNaTaxaDeEntrega ?  'taxaEntrega' :
      (this.cupom.aplicarNaFidelidade ? 'fidelidade' : 'produto');

    if(this.cupom.validade) this.cupom.validade = new Date(this.cupom.validade)

    this.produtos = [{ descricao: ''}]

    if(this.cupom.horarios){
      this.disponibilidadesSemana.forEach( (ds: any) => {
        ds.disponivel =    this.cupom.horarios.find( horario => horario.dia === ds.dia) != null
      })
    }

    if(this.cupom.produtos && this.cupom.produtos.length){
      for( let produto of this.cupom.produtos){
        produto.descricao = String(`${produto.id} - ${produto.nome}`);
        this.produtos.push(produto)
      }
    }

    if(this.cupom.percentualMaximoDescontoProduto > 0)
      this.cupom.naoAplicarProdutosComDesconto = true

    if(this.cupom.id){
      this.cuponsService.jaUsou(this.cupom.id).then((resposta) => {
         this.cupom.jaUtilizado = resposta;
      })
    }
  }

  alvoSeraProdutos(){
    this.cupom.aplicarNaTaxaDeEntrega = false;
    this.cupom.aplicarNaFidelidade = false;
  }

  alvoSeraTaxaEntrega(){
    this.cupom.aplicarNaTaxaDeEntrega = true;
    this.cupom.aplicarNaFidelidade = false;

    if(this.cupom.escopo === 'mesas'){
      this.cupom.escopo = 'livre'
      this.cupom.formaEntrega = ''
    }
  }

  alvoSeraFidelidade(){
    this.cupom.aplicarNaFidelidade = true;
    this.cupom.aplicarNaTaxaDeEntrega = false;
  }

  onSalvar() {
    delete this.mensagemSucesso;
    delete this.mensagemErro;
    if(this.frm.invalid){
      const comErro = this.secoes.find( s => this.secaoComErro(s.id));
      if(comErro) this.secao = comErro.id;
      return;
    }
    if(this.frm.valid){
      this.salvando = true;
      this.cupom.horarios = this.disponibilidadesSemana.filter( (ds: any) => ds.disponivel)
      this.cuponsService.salveCupom(this.cupom).then( (resp) => {
        this.mensagemSucesso = 'Cupom salvo com sucesso!'
        if(!this.cupom.id)
          this.cupom.id = resp.id;
        this.salvando = false;
        setTimeout(() => {
          delete this.mensagemSucesso;
        }, 5000)
      }).catch( erro => {
        this.salvando = false;
        this.mensagemErro = erro;
      })
    }
  }

  gereCodigoCupom() {
    let codigo = "";
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for( let i = 0; i < 10; i++ )
      codigo += possible.charAt(Math.floor(Math.random() * possible.length));

    this.cupom.codigo = codigo;
  }

  copieCodigo() {
    const codigo = this.cupom.codigo;
    if(!codigo) return;

    const marqueCopiado = () => {
      this.codigoCopiado = true;
      clearTimeout(this.timerCopiado);
      this.timerCopiado = setTimeout(() => this.codigoCopiado = false, 2000);
    };

    if(navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(codigo).then(marqueCopiado).catch(() => this.copieComTextarea(codigo, marqueCopiado));
      return;
    }

    this.copieComTextarea(codigo, marqueCopiado);
  }

  // fallback para navegador sem Clipboard API (mesmo jeito do grid de cupons)
  private copieComTextarea(texto: string, depois: () => void) {
    const caixa = document.createElement('textarea');
    caixa.style.position = 'fixed';
    caixa.style.left = '0';
    caixa.style.top = '0';
    caixa.style.opacity = '0';
    caixa.value = texto;
    document.body.appendChild(caixa);
    caixa.focus();
    caixa.select();
    document.execCommand('copy');
    document.body.removeChild(caixa);
    depois();
  }

  fechar() {
    this.windowRef.close(this.cupom.id ? this.cupom : null);
  }


  search($event: string) {
    if(this.timerBusca) clearTimeout(this.timerBusca);

    this.timerBusca = setTimeout( () => {
      this.busqueProdutos($event)
    }, 1000)

  }

  searchCategoria(texto: string){
    if(texto){
      this.categorias = this.empresa.categorias.filter((categoria) => categoria.nome.toLowerCase().indexOf(texto.toLowerCase()) !== -1);
    } else {
      this.categorias = this.empresa.categorias;
    }
  }

  busquePrimeiraVez() { //
    if(!this.produtos.length){
      this.busqueProdutos();
    }
  }

  busqueProdutos(texto: string = ''){
    if(this.buscando) return;

    this.buscando = true;

    this.produtoService.autoComplete( texto).then (  (produtos) => {
      this.produtos = produtos;
      this.buscando = false;
    }).catch( () => {
      this.buscando = false;
    })

  }

  obtenhaFormatoPercentual(){
    return String(`0"%"`);
  }

  alterouComboProduto(item) {
    if(this.cupom.minimoApenasNoValorProduto) return;

    if(item && item.id){
      this.cupom.produtoNaoComporMinimo = true;
    } else {
      this.cupom.produtoNaoComporMinimo = false;
    }
  }

  secaoComErro(secao: string): boolean {
    if(!this.frm) return false;
    return this.camposPorSecao[secao].some( (nome: string) => this.frm.controls[nome] && this.frm.controls[nome].invalid);
  }

  algumDiaMarcado(): boolean {
    return this.disponibilidadesSemana.some( ds => ds.disponivel);
  }

  rotuloAlvo(): string {
    if(this.cupom.alvo === 'taxaEntrega') return 'Desconto na entrega';
    if(this.cupom.alvo === 'fidelidade') return 'Cashback turbinado';
    return 'Desconto no pedido';
  }

  textoDesconto(): string {
    const percentual = this.cupom.tipo === EnumTipoDeCupom.Percentual;
    const numero = percentual ? this.cupom.percentual : this.cupom.valor;
    const valor = percentual ? `${numero || 0}%` : this.formateReais(numero || 0);

    if(this.cupom.alvo === 'fidelidade') return `+${valor} cashback`;
    if(this.cupom.alvo === 'taxaEntrega' && percentual && numero >= 100) return 'Entrega grátis';

    return `${valor} OFF`;
  }

  // todas as condições do cupom, na ordem das seções, para a prévia
  regrasResumo(): Array<string> {
    return [...this.regrasPedidos(), ...this.regrasQuem(), ...this.regrasQuando(), ...this.regrasExtras()];
  }

  resumoSecao(secao: string): string {
    if(secao === 'desconto') return this.cupom.nome || 'Código e desconto';

    if(secao === 'quem') {
      const regras = this.regrasQuem();
      if(!regras.length) return 'Todos os clientes';
      return regras.length === 1 ? regras[0] : `${regras.length} restrições`;
    }

    if(secao === 'pedidos') {
      const regras = this.regrasPedidos();
      if(!regras.length) return 'Qualquer pedido';
      return regras.length <= 2 ? regras.join(' · ') : `${regras[0]} · +${regras.length - 1}`;
    }

    const partes = [this.cupom.validade ? `Até ${moment(this.cupom.validade).format('DD/MM')}` : 'Sem data limite'];
    if(this.algumDiaMarcado()) partes.push(this.textoDias());
    if(this.cupom.quantidade || this.cupom.qtdeMaxima) partes.push('Usos limitados');
    return partes.join(' · ');
  }

  private regrasQuem(): Array<string> {
    const regras = [];

    if(this.cupom.primeiraCompra) regras.push('Só 1ª compra');
    if(this.cupom.restrito) regras.push('Lista de contatos');
    if(this.cupom.restritoContatoPerdido) regras.push('Contatos perdidos');
    if(this.cupom.restritoAniversariantes) regras.push('Aniversariantes');

    return regras;
  }

  private regrasPedidos(): Array<string> {
    const regras = [];

    if(this.cupom.valorMinimo > 0) regras.push(`Pedido mín. ${this.formateReais(this.cupom.valorMinimo, true)}`);

    const escopo = this.escopos.find( e => e.valor === this.cupom.escopo);
    if(escopo && escopo.valor !== 'livre') regras.push(escopo.label);

    const forma = this.formasEntrega.find( f => f.valor && f.valor === this.cupom.formaEntrega);
    if(forma && this.cupom.escopo !== 'mesas' && !this.cupom.aplicarNaTaxaDeEntrega)
      regras.push(`Só ${forma.label.toLowerCase()}`);

    const pagamentos = this.nomes(this.cupom.formasDePagamento, 'descricao');
    if(pagamentos.length)
      regras.push(pagamentos.length <= 2 ? `Só ${pagamentos.join(' ou ')}` : `${pagamentos.length} formas de pagamento`);

    const tamanhos = this.nomes(this.cupom.produtosTemplateTamanho, 'descricao');
    if(tamanhos.length)
      regras.push(tamanhos.length === 1 ? `Só ${tamanhos[0]}` : `${tamanhos.length} tamanhos de pizza`);

    const categorias = this.nomes(this.cupom.categorias, 'nome');
    if(categorias.length) {
      if(this.aplicarSomenteNasCategorias && !this.cupom.aplicarNaTaxaDeEntrega && !this.cupom.aplicarNaFidelidade)
        regras.push(`Desconto só em ${categorias.join(', ')}`);
      else
        regras.push(categorias.length <= 2 ? `Com item de ${categorias.join(', ')}` : `Exige ${categorias.length} categorias`);
    }

    const produtos = this.nomes(this.cupom.produtos, 'nome', 'descricao');
    if(produtos.length)
      regras.push(produtos.length <= 2 ? `Com ${produtos.join(' e ')}` : `Exige ${produtos.length} produtos`);

    if(this.cupom.naoAplicarProdutosComDesconto && this.cupom.percentualMaximoDescontoProduto)
      regras.push(`Fora de promoções acima de ${this.cupom.percentualMaximoDescontoProduto}%`);

    return regras;
  }

  private regrasQuando(): Array<string> {
    const regras = [];

    if(this.cupom.validade) regras.push(`Até ${moment(this.cupom.validade).format('DD/MM/YYYY')}`);
    if(this.algumDiaMarcado()) regras.push(this.textoDias());
    if(this.cupom.quantidade) regras.push(this.cupom.quantidade === 1 ? '1 uso no total' : `${this.cupom.quantidade} usos no total`);
    if(this.cupom.qtdeMaxima) regras.push(`${this.cupom.qtdeMaxima} por cliente`);

    return regras;
  }

  private regrasExtras(): Array<string> {
    const regras = [];

    if(this.cupom.selecionavel && !this.cupom.brindeResgate) regras.push('Visível na loja');
    if(this.cupom.naoPontuarFidelidade && !this.cupom.aplicarNaFidelidade && !this.cupom.aplicarNaTaxaDeEntrega)
      regras.push('Não pontua fidelidade');

    return regras;
  }

  // nomes dos itens escolhidos num multiselect, ignorando a opção em branco
  private nomes(itens: Array<any>, campo: string, reserva?: string): Array<string> {
    if(!itens || !itens.length) return [];

    return itens.filter( item => item && item.id)
      .map( item => item[campo] || (reserva ? item[reserva] : ''))
      .filter( nome => !!nome);
  }

  private textoDias(): string {
    const marcados = this.disponibilidadesSemana.filter( ds => ds.disponivel);
    if(marcados.length === this.disponibilidadesSemana.length) return 'Todos os dias';
    return marcados.map( ds => ds.label).join(', ');
  }

  private formateReais(valor: number, centavos = false): string {
    const inteiro = Number(valor) % 1 === 0;
    const digitos = centavos || !inteiro ? 2 : 0;

    return 'R$ ' + Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: digitos, maximumFractionDigits: digitos });
  }

  alterouFormasPagamento(){

  }
}
